import { render, staticRenderFns } from "./Stammdaten.vue?vue&type=template&id=bcbecb52&scoped=true&"
import script from "./Stammdaten.vue?vue&type=script&lang=js&"
export * from "./Stammdaten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbecb52",
  null
  
)

export default component.exports